import { createTheme, type Theme } from '@mui/material';

export interface AppearanceSettings {
  colorMode: 'dark' | 'light';
  largeText: boolean;
}

export const defaultAppearanceSettings: AppearanceSettings = {
  colorMode: 'dark',
  largeText: false,
};

export const createAppTheme = (appearance: AppearanceSettings): Theme =>
  createTheme({
    components: {
      MuiCardActions: {
        styleOverrides: {
          root: {
            '&:last-child': {
              paddingBottom: 24,
            },
            paddingBottom: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24,
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            '&:last-child': {
              paddingBottom: 24,
            },
            paddingBottom: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24,
          },
        },
      },
      MuiCardHeader: {
        styleOverrides: {
          root: {
            '&:last-child': {
              paddingBottom: 24,
            },
            paddingBottom: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            paddingLeft: 24,
            paddingRight: 24,
          },
        },
      },
    },
    palette: {
      mode: appearance.colorMode,
      primary: {
        main: appearance.colorMode === 'light' ? '#1a535c' : '#4ecdc4',
      },
      secondary: {
        main: appearance.colorMode === 'light' ? '#4ecdc4' : '#1a535c',
      },
    },
    shape: { borderRadius: 6 },
    typography: {
      fontFamily: [
        'Montserrat',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      fontSize: appearance.largeText ? 16 : 14,
    },
  });
